import { IonRow } from "@ionic/react";
import styles from "./KeyPad.module.scss";
import KeyPadButton from "./KeyPadButton";

const KeyPad = (props:any) => {

    const { handleClick, handleRemove, compact = false } = props;

    const keypadButtons = [
        [
            { value: "1", letters: "", handleClick: () => handleClick('1'), small: false, remove: false },
            { value: "2", letters: "ABC", handleClick: () => handleClick('2'), small: false, remove: false },
            { value: "3", letters: "DEF", handleClick: () => handleClick('3'), small: false, remove: false }
        ],
        [
            { value: "4", letters: "GHI", handleClick: () => handleClick('4'), small: false, remove: false },
            { value: "5", letters: "JKL", handleClick: () => handleClick('5'), small: false, remove: false },
            { value: "6", letters: "MNO", handleClick: () => handleClick('6'), small: false, remove: false }
        ],
        [
            { value: "7", letters: "PQRS", handleClick: () => handleClick('7'), small: false, remove: false },
            { value: "8", letters: "TUV", handleClick: () => handleClick('8'), small: false, remove: false },
            { value: "9", letters: "WXYZ", handleClick: () => handleClick('9'), small: false, remove: false }
        ],
        [
            { value: "E", letters: "", handleClick: () => handleClick('E'), small: false, remove: false },
            { value: "0", letters: "+", handleClick: () => handleClick('0'), small: false, remove: false },
            { value: "", letters: "", handleClick: () => handleRemove(), small: true, remove: true }
        ]
    ];

    return (
        <div className={`${styles.keypad} ${compact ? styles.compact : ""}`}>
            { keypadButtons.map((keypadRow, index) => (
                <IonRow key={ `keypadRow_${ index }` } className={styles.keypadRow}>
                    { keypadRow.map((button, index2) => {
                        const isDisabled = button.value === undefined;
                        return (
                            <KeyPadButton 
                                key={ `keypadButton_${ index2 }` }
                                value={ button.value }
                                letters={ button.letters }
                                handleClick={ button.handleClick }
                                small={ button.small }
                                remove={ button.remove }
                                isDisabled={ isDisabled } 
                                compact={compact}
                            />
                        );
                    })}
                </IonRow>
            ))}
        </div>
    );
}

export default KeyPad;
